import { FunctionComponent, useContext, useEffect, useState } from 'react'
import { Container } from '@mui/material';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container'
import { AnalyticsReportForm } from '../../../presentation-components/analytics-components/reports/analytics-report-form'
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading'
import { useNavigate, useParams } from 'react-router-dom'
import AnalyticReportService from '../../../../shared/services/analytic-report/analytic-report.service'
import { IAnalyticReportWithFilters, IPostAnalyticReport } from '../../../../shared/services/analytic-report/analytic-report.model'
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';

export const AnalyticsReportsFormPage: FunctionComponent<{ isEditPage: boolean }> = ({ isEditPage }) => {
  const navigate = useNavigate()
  const { id } = useParams()
  //Services
  const analyticReportService = new AnalyticReportService()
  //Context
  const userNotificationsContext = useContext(UserNotificationsContext)
  //State
  const [report, setReport] = useState<IAnalyticReportWithFilters>()
  //Loading State
  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false)

  useEffect(() => {
    if (isEditPage && id) {
      analyticReportService.getOneWithFilters(id)
        .then(response => {
          setReport(response)
        })
        .catch(err => console.log(err))
    }
  }, [])

  const submitCreateHandler = (report: IPostAnalyticReport, resetForm: () => void) => {
    if (!isFormSubmitting) {
      analyticReportService.create(report)
        .then(response => {
          navigate(`/analytics/reports/${response.id}`)
          resetForm()
          setIsFormSubmitting(false)
        })
        .catch(err => {
          setIsFormSubmitting(false)
          userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          console.log(err)
        })
    }
  }

  const submitEditHandler = (report: IPostAnalyticReport, resetForm: () => void) => {
    if (id) {
      if (!isFormSubmitting) {
        analyticReportService.edit(id, report)
          .then(response => {
            navigate(`/analytics/reports/${response.id}`)
            resetForm()
            setIsFormSubmitting(false)
          })
          .catch(err => {
            setIsFormSubmitting(false)
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
            console.log(err)
          })
      }
    }
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title={isEditPage ? ' Edit Analytic Report' : 'Create New Analytic Report'}
        includeBackButton={true}
        backButtonLink='/analytics/reports'
        backButtonText='Back to analytic reports'
      />
      {isEditPage && report &&
        <Container
          maxWidth='lg'>
          <AnalyticsReportForm
            onSubmit={submitEditHandler}
            isEditPage={isEditPage}
            report={report}
            isSubmitting={isFormSubmitting}
          />
        </Container>}
      {!isEditPage &&
        <Container
          maxWidth='lg'>
          <AnalyticsReportForm
            onSubmit={submitCreateHandler}
            isEditPage={isEditPage}
            isSubmitting={isFormSubmitting}
          />
        </Container>}
    </PageOuterContainer>
  )
}